module.exports = __webpack_public_path__ + "static/media/vicePresident.4a97208d.jpg";